/* ************************************************************************** */
/*                                Dependencies                                */
/* ************************************************************************** */

// Lib dependencies
import { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Stack, Container, Box } from '@mantine/core';

// UI local components
import ConfirmBar from '@ui-kit/molecules/ConfirmBar';

// Store
import dialogStoreVar from '@features/Dialog/store/dialogStore';

// Types
import { DialogSupportResourceProps } from './type';
import ResourceSelector from '@features/AIAssistant/PageAIAssistant/SectionRename/ResourceSelector';
import { ResourceIndexView } from '@app/types/blackroom-api';

/* ************************************************************************** */
/*                                  Component                                 */
/* ************************************************************************** */

function DialogSupportResource({
  onConfirm,
  allowFolderSelection = true,
  excludeResourceIds,
  ...props
}: DialogSupportResourceProps) {
  // State
  const [selectedResources, setSelectedResources] = useState<
    ResourceIndexView[]
  >([]);

  // Store
  const dialogStore = useReactiveVar(dialogStoreVar);
  const { closeDialog } = dialogStore ?? {};

  // Locale
  const { t } = useTranslation(['Common', 'Support']);

  /* ******************************** CALLBACKS ******************************* */

  function onSubmit() {
    if (selectedResources) {
      closeDialog?.('dialog-support-resource');
      onConfirm(selectedResources);
    }
  }

  /* ******************************** RENDERING ******************************* */

  return (
    <Container w="780px" fluid>
      <Stack align="stretch">
        <form onSubmit={(e) => e.preventDefault()}>
          <Box h="60vh">
            <ResourceSelector
              selectedResources={selectedResources}
              setSelectedResources={setSelectedResources}
              excludeResourceIds={excludeResourceIds}
            />
          </Box>
        </form>
        <ConfirmBar
          labelProps={{
            confirm: t(
              'Support:QuestionMenu.questionDetails.form.dialogSelectQuestionResource.addFiles',
            ),
            cancel: t('Common:cta.cancel'),
          }}
          onConfirm={onSubmit}
          onCancel={() => {
            dialogStore?.closeDialog?.('dialog-support-resource');
          }}
        />
      </Stack>
    </Container>
  );
}

export default DialogSupportResource;
